class Footer {
	constructor() {
		this.footer = document.querySelector(".footer");

		if (this.footer) {
			this.init();
		}
	}

	init() {
		// Add any interactive functionality here
		$(".footer-items div.footer-section:gt(0)").wrapAll(
			'<div class="footer-grid">'
		);
	}
}